import { forwardRef } from 'react';
import { Disableable, Sized, useComponentProps, Variable } from '@optimus-web/common';
import { IconName } from '@optimus-web/icons';
import { ButtonType, ButtonVariant } from '../Button';
import { VisuallyHidden } from '../helpers/VisuallyHidden';
import { ensureString } from '../utils';
import { IconButtonElement } from './style';

export interface IconButtonProps
    extends Sized,
        Variable<ButtonVariant>,
        Disableable,
        React.ButtonHTMLAttributes<HTMLButtonElement> {
    asTag?: string;
    ref?: React.Ref<HTMLButtonElement>;
    icon: IconName;
    iconSize?: 'small' | 'medium';
    onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
    accessibleText?: React.ReactChild;
    loading?: boolean;
    type: ButtonType;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
    (
        {
            icon,
            size: customSize,
            iconSize = 'small',
            variant,
            accessibleText,
            loading,
            disabled,
            ...other
        }: IconButtonProps,
        ref
    ) => (
        <IconButtonElement
            ref={ref}
            icon={icon}
            iconSize={iconSize}
            size={useComponentProps('IconButton', { size: customSize }).size}
            variant={variant}
            disabled={disabled}
            aria-disabled={disabled ? true : undefined}
            aria-busy={loading ? true : undefined}
            loading={loading}
            aria-label={ensureString({ value: accessibleText })}
            {...other}
        >
            {accessibleText && <VisuallyHidden>{accessibleText}</VisuallyHidden>}
        </IconButtonElement>
    )
);
